/*@jsxRuntime automatic*/
/*@jsxImportSource react*/
import {useMDXComponents as _provideComponents} from "nextra/mdx";
const title = "Yes Icon";
const frontMatter = {};
import {Icon} from '@/components';
import {mdiCheckCircle} from '@mdi/js';
export function useTOC(props) {
  return [];
}
function MDXLayout(props) {
  return <Icon path={mdiCheckCircle} style={{
    color: 'rgb(89, 204, 141)'
  }} aria-label={"Yes"} />;
}

export default MDXLayout